module.exports = __webpack_public_path__ + "c83418a8e93fa880ea6fdce697efa353.pdf";